// components/BottomNav/BottomNav.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BottomNav.css";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: "products", icon: "products", label: "Products", path: "/" },
    {
      id: "quotations",
      icon: "quotations",
      label: "Quotations",
      path: "/quotations",
    },

    { id: "home", icon: "home", label: "Home", path: "/" },
    { id: "orders", icon: "orders", label: "Orders", path: "/orders" },
    {
      id: "payments",
      icon: "payments",
      label: "Payments",
      path: "/transactions",
    },
  ];

  const isActive = (path, itemId) => {
    // make Orders active also for /orders/:orderId
    if (itemId === "orders") return location.pathname.startsWith("/orders");
    return location.pathname === path;
  };

  const getIcon = (iconName) => {
    switch (iconName) {
      case "products":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
        );
      case "orders":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <line x1="3" x2="21" y1="6" y2="6" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
        );
      case "home":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        );
      case "payments":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect width="20" height="14" x="2" y="5" rx="2" />
            <line x1="2" x2="22" y1="10" y2="10" />
          </svg>
        );
      case "quotations":
        return (
          <svg
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 14h6m-6 4h6M9 10h6M7 3h10a2 2 0 012 2v16l-2-1-2 1-2-1-2 1-2-1-2 1V5a2 2 0 012-2z"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex justify-around items-center py-3 z-50">
      {navItems.map((item) =>
        item.id === "home" ? (
          <div
            key={item.id}
            className="relative flex justify-center items-center w-16"
          >
            <button
              onClick={() => navigate(item.path)}
              className={`floating-home w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg ${isActive(item.path, item.id) ? "active" : ""}`}
              aria-label="Home"
            >
              {getIcon(item.icon)}
            </button>
          </div>
        ) : (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={`bottom-nav-item w-full group flex flex-col items-center justify-center ${isActive(item.path, item.id) ? "active text-primary" : "text-gray-900"}`}
            aria-label={item.label}
          >
            <div className="p-1 mb-0.5">{getIcon(item.icon)}</div>
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        ),
      )}
    </nav>
  );
};

export default BottomNav;
